var map = {
	"./_GMN/de.json": 5504,
	"./_GMN/en.json": 2572,
	"./_Megalol/de.json": 225,
	"./_Megalol/en.json": 5013,
	"./_Moin/de.json": 6503,
	"./_Moin/en.json": 175,
	"./_Motivation/de.json": 970,
	"./_Motivation/en.json": 2098,
	"./_Quotes/de.json": 2377,
	"./_Quotes/en.json": 2909,
	"./_Warm/de.json": 6905,
	"./_Warm/en.json": 5565,
	"./_Wishes/de.json": 6143,
	"./_Wishes/en.json": 8951,
	"./de.json": 1272,
	"./en.json": 5188
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5679;